export default __webpack_public_path__ + "static/media/spinner1.e64123a1.gif";